

export const ADD_To_CART ="ADD_TO_CART";
export const REMOVE_FROM_CART="REMOVE_FROM_CART";
export const ADJUST_QTY ="ADJUST_QTY";
export const LOAD_CURRENT_ITEM ="LOAD_CURRENT_ITEM";
export const CHECKOUT_UPDATE ="CHECKOUT_UPDATE";


